import { render, staticRenderFns } from "./Agentes.vue?vue&type=template&id=01d8a183&"
import script from "./Agentes.vue?vue&type=script&lang=js&"
export * from "./Agentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports